"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controller = void 0;
const tslib_1 = require("tslib");
const helpful_decorators_1 = require("helpful-decorators");
const stripAnsi = require("strip-ansi");
/**
 * Overlay controller
 * @public
 */
class Controller {
    /**
     * Class constructor
     * @public
     */
    constructor() {
        this.element = document.createElement('bud-error');
        document.body && document.body.appendChild(this.element);
    }
    /**
     * Formatted error message
     * @public
     */
    get message() {
        var _a;
        return (_a = this.payload.errors) === null || _a === void 0 ? void 0 : _a.reduce((a, c) => {
            var _a, _b;
            return `${a}
        <div>
          <span>${(_a = c === null || c === void 0 ? void 0 : c.title) !== null && _a !== void 0 ? _a : 'Compilation error'}</span>
          <pre>${(_b = stripAnsi.default(c === null || c === void 0 ? void 0 : c.message)) !== null && _b !== void 0 ? _b : ''}</pre>
        </div>`;
        }, ``);
    }
    /**
     * Update element
     * @public
     */
    update(payload) {
        var _a;
        this.payload = payload;
        this.element.setAttribute('message', (_a = this.message) !== null && _a !== void 0 ? _a : ``);
    }
}
tslib_1.__decorate([
    helpful_decorators_1.bind
], Controller.prototype, "update", null);
exports.Controller = Controller;
//# sourceMappingURL=overlay.controller.cjs.map